import { CampaignGroupIdSchema as o, TargetGroupIdSchema as r } from "@hprofits/shared";
import { DimensionsInputSchema as n, DimensionsOutputSchema as m } from "@hprofits/shared/dimensions";
import { z as e } from "zod";
const a = 50, t = e.string().trim().min(1, "name must be non-empty").max(a, `name must be at most ${a} characters`), c = e.string().trim().min(1, "name must be non-empty"), g = e.object({
  dimensions: n
}).strict().readonly(), h = e.object({
  name: t
}).strict().readonly(), i = e.object({
  name: t,
  dimensions: n,
  campaignGroupId: o
}).strict().readonly(), S = e.object({
  sourceId: r,
  name: t
}).strict().readonly(), s = i.unwrap().omit({ dimensions: !0 }).extend({
  id: r,
  name: c,
  dimensions: m
}).readonly(), p = s.unwrap().pick({ id: !0, name: !0 }).extend({ enabled: e.literal(!0) }).readonly(), y = e.array(p).readonly();
export {
  S as CopyTargetGroupSchema,
  i as CreateTargetGroupSchema,
  h as RenameTargetGroupSchema,
  a as TARGET_GROUP_NAME_MAX_LENGTH,
  y as TargetGroupListSchema,
  p as TargetGroupListViewSchema,
  s as TargetGroupSchema,
  g as UpdateTargetGroupSchema
};
//# sourceMappingURL=schemas.js.map
